export const space = {
  xxs: 3,
  xs: 6,
  s: 7,
  m: 10,
  l: 12,
  xl: 14,
  xxl: 15,
};
